import axios from 'axios';
import defaultLogo from '../assets/Empower-logo.png';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { environment } from '../env/environment';
import { useTenant } from '../context/TenantContext';

axios.defaults.withCredentials = true;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Get the logo to display
  const rawLogo = tenant?.signinLogoUrl || tenant?.logoUrl || defaultLogo;
  const isDefaultLogo = !tenant?.signinLogoUrl && !tenant?.logoUrl;
  const logoToDisplay = rawLogo && !rawLogo.startsWith('data:') ? rawLogo + (rawLogo.includes('?') ? '&' : '?') + '_v=' + Date.now() : rawLogo;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${environment.baseUrl}/api/auth/forgot-password`, { email });
      setMessage(response.data.message);
      setError('');
      
      // Navigate to OTP verification page with email as state
      navigate('/verify-otp', { state: { email } });

    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong.');
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className='bg-image-container'>
        <img
          src={logoToDisplay}
          alt={tenant?.brandName || 'Logo'}
          className={isDefaultLogo ? 'default-logo' : ''}
        />
      </div>
      <div className='form-container'>
        <form className="form" onSubmit={handleSubmit}>
          <button
            type="button"
            className="back-btn forgot-btn"
            onClick={loading ? null : () => navigate('/')}
            disabled={loading}
            style={{
              opacity: loading ? 0.6 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            <ArrowBackIosNewIcon className='arrow-icon' /> Back to Login
          </button>

          <div className='signin-heading'>
            <h1>Forgot your password?</h1>
            <p>Don't worry, happens to all of us. Enter your email below to recover your password</p>
          </div>

          <div>
            <div className="flex-column">
              <label>Email <span style={{color:'red'}}>*</span></label>
            </div>
            <div className="inputForm">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your Email"
                className="input"
                required
                disabled={loading}
                style={{
                  opacity: loading ? 0.7 : 1
                }}
              />
            </div>
          </div>

          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <button 
            type="submit" 
            className="button-submit"
            disabled={loading || !email.trim()}
            style={{
              opacity: loading || !email.trim() ? 0.6 : 1,
              cursor: loading || !email.trim() ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;